import Announcement from "./partial/Announcement"

import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import DatePicker from 'react-datepicker';
import ReactGA from 'react-ga4'
import ReactPixel from 'react-facebook-pixel';
import * as actions from '../actions/reservationActions';
import {reservationParameters} from '../types';
import { SEASON_YEAR, SEASON_DATES, PRICING, CONTACT } from '../constants/campConfig';

import "react-datepicker/dist/react-datepicker.css";

export class ReservationPage extends React.Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this);
    this.handleArrivalDateChange = this.handleArrivalDateChange.bind(this);
    this.handleDepartureDateChange = this.handleDepartureDateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = (ev) => {
    this.props.actions.setReservationParameter(ev.target.name, ev.target.value);
  }
  handleArrivalDateChange = (date) => {
    this.props.actions.setReservationParameter("arrivalDate", date);
  }
  handleDepartureDateChange = (date) => {
    this.props.actions.setReservationParameter("departureDate", date);
  }

  handleSubmit = () => {
    try {
      ReactGA.event('generate_lead', {
        event_category: 'reservation',
        event_label: 'weekender',
      });
      ReactPixel.track("Lead", { 
        value: "Weekender",
      });
    } catch (e) { /* tracking should never block form submission */ }
    // allow tracking events to flush before submitting
    setTimeout(() => this.props.actions.submitReservation(), 300);
  }

  render() {
    return (
      <div id="reservation-page">
        <Helmet>
          <title>Book a Reservation | Red Rock Ponds RV Resort</title>
          <meta name="description" content="Reserve your campsite at Red Rock Ponds RV Resort online. Daily, weekly, and monthly rates available. Full hookup sites on the Erie Canal in Holley, NY." />
        </Helmet>
        <Announcement/>
        <section className="section">
          <div className="container">
            <div className="columns">
              <div className="column is-8">
                <div className="columns">
                  <div className="column is-full">
                    <h1 className="title">Reservation</h1>
                    <p>Red Rock Ponds RV Resort now offers the option of making your camping reservation online. Simply complete
                      the form below to start! We look forward to welcoming you to our park! Please don&apos;t hesitate to
                      contact us regarding any online booking issues you may encounter. We reserve the right to make adjustments
                      to your online booking, you will be notified of any changes made.</p><br/>
                    <p><strong>Contact us for monthly reservations if no availability is found online, we might be able to help!
                      Locking fees are waived for group reservations of 3 or more. </strong></p><br/>
                    <div className="notification is-info is-light mt-2">
                      Call us at <strong>{CONTACT.phone}</strong> should you experience any issue while booking online.
                    </div>
                  </div>
                </div>
                <div className="columns is-multiline">
                  <div className="column is-6">
                    <label className="label">Arrival<strong className="has-text-danger">*</strong></label>
                    <div className="field">
                      <div className="control">
                        <DatePicker className="input"
                                    selected={this.props.reservationParameters.fields.arrivalDate.value}
                                    onChange={this.handleArrivalDateChange}
                                    selectsStart
                                    startDate={this.props.reservationParameters.fields.arrivalDate.value}
                                    endDate={this.props.reservationParameters.fields.departureDate.value}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="column is-6"><label className="label">Departure<strong
                    className="has-text-danger">*</strong></label>
                    <div className="field">
                      <div className="control">
                        <DatePicker className="input"
                                    selected={this.props.reservationParameters.fields.departureDate.value}
                                    onChange={this.handleDepartureDateChange}
                                    selectsEnd
                                    startDate={this.props.reservationParameters.fields.arrivalDate.value}
                                    endDate={this.props.reservationParameters.fields.departureDate.value}
                                    minDate={this.props.reservationParameters.fields.arrivalDate.value}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="hr"/>
                <div className="columns is-multiline">
                  <div className="column is-4">
                    <div className="field">
                      <label className="label">Number of Adults<strong className="has-text-danger">*</strong></label>
                      <div className="control is-expanded">
                        <div
                          className={`select is-fullwidth ${this.props.reservationParameters.fields.numOfAdults.error ? "is-danger" : ""}`}>
                          <select name="numOfAdults" value={this.props.reservationParameters.fields.numOfAdults.value}
                                  onChange={this.handleChange}>
                            <option value="">&nbsp;&nbsp;&nbsp;</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                          </select>
                        </div>
                        <p
                          className={`help is-danger has-text-danger ${this.props.reservationParameters.fields.numOfAdults.error ? "" : "is-hidden"}`}>{this.props.reservationParameters.fields.numOfAdults.message}</p>
                      </div>
                    </div>
                  </div>
                  <div className="column is-4">
                    <div className="field">
                      <label className="label">Number of Children<strong
                        className="has-text-danger">*</strong></label>
                      <div className="control is-expanded">
                        <div
                          className={`select is-fullwidth ${this.props.reservationParameters.fields.numOfChildren.error ? "is-danger" : ""}`}>
                          <select name="numOfChildren"
                                  value={this.props.reservationParameters.fields.numOfChildren.value}
                                  onChange={this.handleChange}>
                            <option value="">&nbsp;&nbsp;&nbsp;</option>
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                          </select>
                        </div>
                        <p
                          className={`help is-danger has-text-danger ${this.props.reservationParameters.fields.numOfChildren.error ? "" : "is-hidden"}`}>{this.props.reservationParameters.fields.numOfChildren.message}</p>
                      </div>
                    </div>
                  </div>
                  <div className="column is-4">
                    <div className="field">
                      <label className="label">Number of Pets<strong className="has-text-danger">*</strong></label>
                      <div className="control is-expanded">
                        <div
                          className={`select is-fullwidth ${this.props.reservationParameters.fields.numOfPets.error ? "is-danger" : ""}`}>
                          <select name="numOfPets" value={this.props.reservationParameters.fields.numOfPets.value}
                                  onChange={this.handleChange}>
                            <option value="">&nbsp;&nbsp;&nbsp;</option>
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                          </select>
                        </div>
                        <p
                          className={`help is-danger has-text-danger ${this.props.reservationParameters.fields.numOfPets.error ? "" : "is-hidden"}`}>{this.props.reservationParameters.fields.numOfPets.message}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="hr"/>
                <div className={`message
                  ${this.props.reservationParameters.validation.valid ? "is-hidden" : "is-danger"}`}>
                  <div className="message-body">
                    <div className="content">
                      <p>
                        {this.props.reservationParameters.validation.message}
                      </p>
                    </div>
                  </div>
                </div>
                <div className={`message
                  ${this.props.reservationParameters.response.type === "success" ? "is-success" : "is-danger"}
                  ${this.props.reservationParameters.response.type === "url" ? "is-hidden" : ""}
                  ${this.props.reservationParameters.response.type ? "" : "is-hidden"}
                  `}>
                  <div className="message-body">
                    <div className="content">
                      <p>
                        {this.props.reservationParameters.response.message}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="field is-grouped is-grouped-right">
                  <div className="control"> 
                    <button className="button is-link" onClick={this.handleSubmit}>Search</button>
                  </div>
                  <div className="control">
                    <button className="button is-link is-light">Cancel</button>
                  </div>
                </div>
              </div>
              <div className="column is-4">
                <article className="message is-success">
                  <div className="message-header">
                    <p>Rates</p>
                  </div>
                  <div className="message-body">
                    <p>{SEASON_YEAR} Season Runs:<br/>
                      <strong>{SEASON_DATES.openingDate} - {SEASON_DATES.closingDate}</strong></p>
                    <br/>
                    <h5 className="title is-5">Daily Rates</h5>
                    <dl className="no-style">
                      <li><strong>Weekdays:</strong><span className="is-pulled-right">${PRICING.daily.weekday.toFixed(2)}</span></li>
                      <li><strong>Weekends:</strong><span className="is-pulled-right">${PRICING.daily.weekend.toFixed(2)}*</span></li>
                      <li><strong>Holidays:</strong><span className="is-pulled-right">${PRICING.daily.holiday.toFixed(2)}*</span></li>
                    </dl>
                    <p>*{PRICING.notes.holiday}</p>
                    <hr className="hr"/>
                    <h5 className="title is-5">Weekly Rates</h5>
                    <dl className="no-style">
                      <li><strong>Regular:</strong><span className="is-pulled-right">${PRICING.weekly.regular}*</span></li>
                      <li><strong>Peak ({PRICING.weekly.peakMonths}):</strong><span className="is-pulled-right">${PRICING.weekly.peak}*</span></li>
                    </dl>
                    <p>*{PRICING.notes.weeklyHoliday}</p>
                    <hr className="hr"/>
                    <h5 className="title is-5">Monthly Rates</h5>
                    <dl className="no-style">
                      <li><strong>Month (30 days):</strong><span className="is-pulled-right">${PRICING.monthly.base} {PRICING.monthly.note}*</span>
                      </li>
                    </dl>
                    <p>*{PRICING.notes.monthlyHoliday}</p>
                    <hr className="hr"/>
                    <h5 className="title is-5">Golf Cart Rentals</h5>
                    <dl className="no-style">
                      <li><strong>{PRICING.golfCart.weekdayLabel}:</strong><span className="is-pulled-right">${PRICING.golfCart.weekday.toFixed(2)}/night</span></li>
                      <li><strong>{PRICING.golfCart.weekendLabel}:</strong><span className="is-pulled-right">${PRICING.golfCart.weekend.toFixed(2)}/night</span></li>
                    </dl>
                    <p>{PRICING.notes.golfCart}</p>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  componentDidUpdate() {
    if (this.props.reservationParameters.response.type === "url") {
      const url = "https://www.campspot.com/book/redrockpondsrvresort/search".concat(this.props.reservationParameters.response.message);
      ReactGA.event('search', {
        event_category: 'reservation',
        search_term: 'campsite_availability',
      });
      window.location.assign(url);
    }
  }
}

ReservationPage.propTypes = {
  actions: PropTypes.object.isRequired,
  reservationParameters: reservationParameters.isRequired
};

function mapStateToProps(state) {
  return {
    reservationParameters: state.reservationParameters
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReservationPage);
